import { createModalProvider } from "~components/shared/ModalContext/ModalContext";
import type { Team } from "~generated";
import type { Resource } from "~lib/resourceHelpers.ts";
import { EditTeamModal } from "./EditTeamModal";

export interface EditTeamModalData {
  team: Team;
  additionalResources?: Resource[];
  onSuccess?: (added: Resource[], removed: Resource[]) => void;
}

export const { provider: EditTeamModalProvider, hook: useEditTeamModal } =
  createModalProvider<EditTeamModalData>(EditTeamModal);
